module.exports = __webpack_public_path__ + "assets/img/38cb7a2fa0a2afe393b479f7044e5fef.webp";